import BasicContentSimpleStatStack from './BasicContentSimpleStatStack';

export { type BasicContentSimpleStatStackProps } from './BasicContentSimpleStatStack';
export default BasicContentSimpleStatStack;
